import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useApiContext } from 'context/ApiContext';

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";

// Material Dashboard 2 React base styles
import breakpoints from "assets/theme/base/breakpoints";

// Images
import role from "assets/images/user_bleu.png";

function Header({ children, user = null, currentRole, formType, ...rest }) {
    const [tabsOrientation, setTabsOrientation] = useState("horizontal");
    const navigate = useNavigate();

    const { setUserFormInfosAdm } = useApiContext();

    useEffect(() => {
        // A function that sets the orientation state of the tabs.
        function handleTabsOrientation() {
            return window.innerWidth < breakpoints.values.sm
                ? setTabsOrientation("vertical")
                : setTabsOrientation("horizontal");
        }

        /** 
         The event listener that's calling the handleTabsOrientation function when resizing the window.
        */
        window.addEventListener("resize", handleTabsOrientation);

        // Call the handleTabsOrientation function to set the state with the initial value.
        handleTabsOrientation();

        // Remove event listener on cleanup
        return () => window.removeEventListener("resize", handleTabsOrientation);
    }, [tabsOrientation]);

    const handleReturnClick = () => {
        setUserFormInfosAdm({
            selectedUser: null,
            formType: "Tab",
        });
        console.log("Return Tab");
    };

    return (
        <MDBox position="relative" mb={5} mt={1}>
            <Card
                sx={{
                    left: "0",  // Aligne le Card à gauche de l'image
                    right: "0", // Aligne le Card à droite de l'image
                    py: 2,
                    px: 3,
                }}
            >
                <Grid container spacing={3} alignItems="center" ml={0.5}>
                    <Grid item>
                        <MDAvatar src={role} alt="profile-image" size="md" shadow="sm" />
                    </Grid>
                    <Grid item>
                        <MDBox height="100%" mt={(currentRole !== "AdminAT" || formType === "VisualizeUser") ? 2 : 1} lineHeight={1}>
                            <MDTypography variant="h4" fontWeight="medium">
                                {user?.lastName || "NEW"} {user?.name || "User"}
                            </MDTypography>
                            {(currentRole !== "AdminAT" || formType === "VisualizeUser") && (
                                <MDTypography variant="h6" color="text" fontWeight="regular">
                                    {user?.role || "AdminPark"}
                                </MDTypography>
                            )}
                        </MDBox>
                    </Grid>
                    <Grid item mr={3} sx={{ display: 'flex', justifyContent: 'flex-end', flexGrow: 1 }}>
                        <MDButton
                            onClick={handleReturnClick}
                            sx={{
                                '&:hover': {
                                    backgroundColor: "#f0f2f5", // Couleur au survol
                                },
                            }}
                        >
                            <MDBox
                                sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                            >
                                <Icon color="secondary" fontSize="large">arrow_back</Icon>
                                <MDTypography variant="h6" color="secondary" fontWeight="medium">
                                    RETURN
                                </MDTypography>
                            </MDBox>
                        </MDButton>
                    </Grid>
                </Grid>
                {children}
            </Card>
        </MDBox>
    );
}

// Setting default props for the Header
Header.defaultProps = {
    children: "",
};

// Typechecking props for the Header
Header.propTypes = {
    children: PropTypes.node,
};

export default Header;
